<template>
  <div class="big">
    <div class="page_title flex_between">
      <span>统计列表</span>
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <el-tabs v-model="activeName">
            <el-tab-pane label="回访统计" name="1"></el-tab-pane>
            <el-tab-pane
              label="日常工作统计"
              name="2"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1839') : false
              "
            ></el-tab-pane>
            <el-tab-pane
              label="发货统计"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('2074') : false
              "
              name="3"
            ></el-tab-pane>
          </el-tabs>
          <component :is="currentComponent" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StatisticsList from "./StatisticsList.vue";
import DailyWorkData from "./DailyWorkData.vue";
import HospitalSend from "./HospitalSend.vue";
export default {
  components: {
    StatisticsList,
    DailyWorkData,
    HospitalSend,
  },
  data() {
    return {
      activeName: "1",
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    currentComponent() {
      switch (this.activeName) {
        case "1":
          return StatisticsList;
        case "2":
          return DailyWorkData;
        case "3":
          return HospitalSend;
        default:
          return StatisticsList;
      }
    },
  },
  created() {},
  methods: {
    back() {
      history.back();
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 10px;
  text-align: left;
}
</style>